import { createDecorator } from 'vue-class-component';

export const prop = createBindingHelper('props');

function createBindingHelper(bindTo) {
   return function makeDecorator(map = {}) {
      return createDecorator(function _decorator(options, key) {
         options[bindTo] = options[bindTo] || {};
         options[bindTo][key] = map;
      });
   };
}
